import { useCallback, useState } from 'react';

type TViewApproveRouteDrawerProps = () => {
  onDrawerOpen: () => void;
  onDrawerClose: () => void;
  isOpen: boolean;
};

export const useViewApproveRouteDrawer: TViewApproveRouteDrawerProps = () => {
  const [isOpen, setIsOpen] = useState(false);

  const onDrawerOpen = useCallback(() => {
    if (!isOpen) {
      setIsOpen(true);
    }
  }, [isOpen, setIsOpen]);

  const onDrawerClose = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  return {
    isOpen,
    onDrawerOpen,
    onDrawerClose,
  };
};
